export const parseTraceId = (headers: Headers | undefined): string | undefined =>
  headers?.get('uber-trace-id')?.split(':')[0];
